import React from 'react';
import {BaseFieldProps} from '../../index';
import View from './view';

export const BaseFieldRadio: React.FC<BaseFieldProps> = ({
  labelStyle,
  label,
  dotStyle,
  disabled,
  input,
  onCustomBlur,
  meta,
}) => {
  return View({
    label,
    disabled,
    labelStyle,
    value: input.value,
    checked: input.checked,
    onChange: (value) => {
      if (input.onChange) {
        input.onChange(value);
      }

      if (onCustomBlur) {
        onCustomBlur(null, meta?.form, input.name, value);
      }
    },
    wrapExtraStyles: dotStyle,
  });
};
